import { render } from "./Dashboard1.vue?vue&type=template&id=70394caa"
import script from "./Dashboard1.vue?vue&type=script&lang=js"
export * from "./Dashboard1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__